// src/Components/Contact.js
import React, { useState } from 'react';
import { FaMapMarkerAlt, FaPhoneAlt, FaWhatsapp, FaClock, FaEnvelope } from 'react-icons/fa';
import './Contact.css';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '', email: '', phone: '', message: ''
    });
    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Contact Form Submitted:', formData);
        setIsSubmitted(true);
        setTimeout(() => setIsSubmitted(false), 5000);
        setFormData({ name: '', email: '', phone: '', message: '' });
    };

    // Google Maps Embed URL (Gulshan-e-Iqbal, Karachi)
    const mapUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28959.64772225046!2d67.0896707!3d24.9004969!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33f1c0c4b6d5d%3A0x8e8e8e8e8e8e8e8e!2sGulshan-e-Iqbal%2C%20Karachi%2C%20Pakistan!5e0!3m2!1sen!2s!4v1700000000000!5m2!1sen!2s";

    return (
        <div className="contact-page">
            {/* Hero Section */}
            <section className="page-hero-banner">
                <div className="container">
                    <h1>Get In Touch</h1>
                    <p>We're Here to Help You Smile</p>
                </div>
            </section>

            <div className="container section-padding">
                <div className="row">
                    {/* Contact Information - Left Aligned */}
                    <div className="col-lg-6 mb-5 mb-lg-0">
                        <div className="contact-info p-4">
                            <h2 className="text-left">Our Contact Information</h2>
                            <p className="text-left">You can reach us through the following channels.</p>
                            
                            <div className="info-item">
                                <FaMapMarkerAlt className="info-icon" />
                                <div className="info-content">
                                    <h5>Our Address</h5>
                                    <p>Bagh-E-Rizwan Apartment, Gulshan-E-Iqbal, Karachi - Pakistan.</p>
                                </div>
                            </div>

                            <div className="info-item">
                                <FaPhoneAlt className="info-icon" />
                                <div className="info-content">
                                    <h5>Call Us</h5>
                                    <p>+92 300 257 3177</p>
                                </div>
                            </div>

                            <div className="info-item">
                                <FaWhatsapp className="info-icon" />
                                <div className="info-content">
                                    <h5>WhatsApp</h5>
                                    <p>+92 300 257 3177</p>
                                </div>
                            </div>

                            <div className="info-item">
                                <FaEnvelope className="info-icon" />
                                <div className="info-content">
                                    <h5>Email Us</h5>
                                    <p>consult@parachadental.com</p>
                                </div>
                            </div>

                            <div className="info-item">
                                <FaClock className="info-icon" />
                                <div className="info-content">
                                    <h5>Our Hours</h5>
                                    <p><strong>Morning:</strong> Monday – Thursday & Saturday: 10:00am – 2:30pm</p>
                                    <p className="mb-0"><strong>Evening:</strong> Monday – Saturday: 6:00pm – 10:00pm</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Google Map */}
                    <div className="col-lg-6">
                        <div className="map-wrapper p-4">
                            <h2 className="text-left">Find Us Here</h2>
                            <p className="text-left">Visit our clinic at the following location.</p>
                            <div className="google-map">
                                <iframe
                                    title="Clinic Location"
                                    src={mapUrl}
                                    width="100%"
                                    height="400"
                                    style={{ border: 0, borderRadius: '12px' }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                ></iframe>
                            </div>
                            <div className="map-directions mt-3">
                                <a 
                                    href="https://maps.app.goo.gl/HFnUompEkHU9pUzCA" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="btn btn-outline-primary w-100"
                                >
                                    Get Directions →
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;